var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",attrs:{"id":"app"}},[_c('div',{staticClass:"maincontent"},[_c('Header'),_c('main',{staticClass:"content"},[_c('transition',[_c('router-view')],1),_c('ErrorModal')],1)],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }